import React from 'react';
import TransparentButton from '../../../../shared/button/transparent-button/TransparentButton';
import { Connection } from '../simulation.model';

/*
  Says that what is shown may be behind, in one place, instead of a message for each read that failed: the backend restarts on
  every deploy, so a read failing for a moment is expected. onRetry is for when the screen has given up.
*/
export const ConnectionHint = ({ connection, onRetry }) => {
    if (connection === Connection.RECONNECTING) {
        return (
            <div className={'sim-banner warning connection-hint'}>
                <i className={'material-icons'}>sync_problem</i>
                <div>
                    Reconnecting… The server did not answer. What is shown is
                    what it last said.
                </div>
            </div>
        );
    }
    if (connection === Connection.LOST) {
        return (
            <div className={'sim-banner error connection-hint'}>
                <i className={'material-icons'}>cloud_off</i>
                <div>
                    The server could not be reached, so what is shown may be out
                    of date. A run goes on in the server whether it is looked at
                    or not.
                    {onRetry && (
                        <TransparentButton onClick={onRetry}>
                            Try again
                        </TransparentButton>
                    )}
                </div>
            </div>
        );
    }
    return null;
};
